import React from 'react'
import Helmet from 'react-helmet'
import { Link, graphql } from "gatsby"

import styled from 'styled-components';

import Content, { HTMLContent } from '../components/Content'
import TemplateWrapper from '../components/layout'
import googleTagManagerHead from '../shared/googleTagManagerHead'

import facebookLogo from '../img/facebookLogo.svg'
import twitterLogo from '../img/twitterLogo.svg'
import bitFistWhite from '../img/bitFistWhite.svg'

import Button from '../components/shared/Button'
import ArticleType from '../components/shared/ArticleType'
import Category from '../components/home/Category'
import PostStyle from './PostStyle';

// import {buildNewsArticleJsonLd }from '../transformers/jsonLdTransformer'

const NewsFooterStyle = styled.div`
  {
    padding: 14px 25px 17px 25px;
    background-color: #ffffff;
    border-radius: 4px;
    margin: 10px 10px 13px 10px;

    @media (max-width: 700px){
      margin: 10px;
    }
  }
`

const checkImgUrl = (imgUrl) => {
  if ( imgUrl.startsWith('http://bitwpeditorial.s3.amazonaws.com') || imgUrl.startsWith('https://s3.amazonaws.com/')){
    return imgUrl
  } 
  return `https://news.bandsintown.com${imgUrl}`
}

const jsonLD = (indivPost) => {
  const isoDate = new Date(indivPost.frontmatter.date).toISOString()

  return (
    <script type="application/ld+json">{`
      {
        "@context": "http://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": "https://news.bandsintown.com${indivPost.fields.slug}",
        "headline": "${indivPost.frontmatter.description}",
        "datePublished": "${isoDate}",
        "dateModified": "${isoDate}",
        "image": ${checkImgUrl(indivPost.frontmatter.image)},
        "publisher": {
          "@type": "Organization",
          "name": "Bandsintown",
          "logo": {
            "@type": "ImageObject",
            "url": "https://news.bandsintown.com/img/bit-fist.png",
            "height": "1952px",
            "width": "2000px"
          }
        },
        "author" : {
          "@type": "Person",
          "name" : "${indivPost.frontmatter.author}"
        }
        
      } 
    `}</script>
  )
}

export class PostTemplate extends React.Component {
  
  static renderTrackButton(artistId){
    if(artistId === undefined || artistId === "" || artistId === "null" || artistId === null || artistId === "undefined") {
      return null
    }
    return <Button 
      logo={bitFistWhite} 
      type="bandsintown" 
      shareURL={`https://www.bandsintown.com/a/${artistId}?came_from=265&trigger=track&utm_medium=web&utm_source=news_site&utm_campaign=track`}
     />
  }

  render(){
    const {
      content,
      contentComponent,
      description,
      tags,
      image,
      title,
      helmet,
      date,
      author,
      postType, 
      articleTag,
      recentArticles,
      slug,
      artistId,
      FB_APP_ID
    } = this.props

    const PostContent = contentComponent || Content
    return (
      
      <div>
        <TemplateWrapper>

          {helmet}
          <PostStyle>
            <div className="postContainer">
              <div className="title">
                {title} 
              </div>
              <div className="description">
                {description}
              </div>
              <div className="articleTypeContainer">
                <ArticleType articleTag={articleTag} tags={tags} />
              </div>
              <div className="dateAndAuthor">
                {date} | {author}
              </div>
              <div className="shareButtons">
                  {PostTemplate.renderTrackButton(artistId)}
                  <Button
                    logo={facebookLogo}
                    type="facebook"
                    shareURL={`https://www.facebook.com/dialog/share?app_id=${FB_APP_ID}&display=popup&href=https://news.bandsintown.com${slug}&redirect_uri=https://news.bandsintown.com${slug}`}
                  />
                  <Button
                    logo={twitterLogo}
                    type="twitter"
                    shareURL={`https://twitter.com/intent/tweet?url=https://news.bandsintown.com${slug}&text=${title} via @Bandsintown`}
                  />
              </div>
              <div>
                <img src={`${image}?nf_resize=fit&w=720`} alt=""/>
              </div>
              <PostContent content={content} />
              <div className="shareButtons">
                  {PostTemplate.renderTrackButton(artistId)}
                  <Button
                    logo={facebookLogo}
                    type="facebook"
                    shareURL={`https://www.facebook.com/dialog/share?app_id=${FB_APP_ID}&display=popup&href=https://news.bandsintown.com${slug}&redirect_uri=https://news.bandsintown.com${slug}`}
                  />
                  <Button
                    logo={twitterLogo}
                    type="twitter"
                    shareURL={`https://twitter.com/intent/tweet?url=https://news.bandsintown.com${slug}&text=${title} via @Bandsintown`}
                  />
              </div>
            </div>
          </PostStyle>
        <NewsFooterStyle>
          <Category {...recentArticles} />
        </NewsFooterStyle>
        </TemplateWrapper>
      </div>
    )
  }
}

const Post = ({ data }) => {
  const {indivPost, recentPosts} = data
  const recentArticles = {
    categoryTitle: "Recent",
    categoryUrl: "",
    articleList: recentPosts.edges.map((edge) => ({
      title: edge.node.frontmatter.title,
      imageUrl: edge.node.frontmatter.image,
      date: edge.node.frontmatter.date,
      author: edge.node.frontmatter.author,
      slug: edge.node.fields.slug,
      postType: edge.node.frontmatter.postType,
    }))
  }

  // console.log("artist info", indivPost)

  return (
    <PostTemplate
      content={indivPost.html}
      contentComponent={HTMLContent}
      description={indivPost.frontmatter.description}
      tags={indivPost.frontmatter.tags}
      title={indivPost.frontmatter.title}
      image={indivPost.frontmatter.image}
      date={indivPost.frontmatter.date}
      author={indivPost.frontmatter.author}
      postType={indivPost.frontmatter.postType}
      recentArticles={recentArticles}
      slug={indivPost.fields.slug}
      artistId={indivPost.frontmatter.artistId}
      articleTag={indivPost.frontmatter.articleTag}
      FB_APP_ID='1860911374192910'
      helmet={ 
        <Helmet>
          <title> {indivPost.frontmatter.title} </title>
          <meta name="description" content={indivPost.frontmatter.description}/>
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:site" content="@Bandsintown" />
          <meta property="og:url" content={`https://news.bandsintown.com${indivPost.fields.slug}`} />
          <meta property="og:title" content={indivPost.frontmatter.title} />
          <meta property="og:description" content= {indivPost.frontmatter.description} />
          <meta property="og:image" content={checkImgUrl(indivPost.frontmatter.image)} />
          {/* <link rel="canonical" href={`https://news.bandsintown.com${indivPost.fields.slug}`} />
          <link rel="amphtml" className="amphtml" href={`https://news.bandsintown.com/amp${indivPost.fields.slug}`} /> */}
          {jsonLD(indivPost)}
          {googleTagManagerHead({id: indivPost.frontmatter.artistId})}
        </Helmet>
      }
    />
  )
}



// Post.propTypes = {
//   data: PropTypes.shape({
//     markdownRemark: PropTypes.object,
//   }),
// }

export default Post

export const pageQuery = graphql`
query($id: String!) {
  indivPost: markdownRemark(id: { eq: $id }) {
    id
    html
    fields {
      slug
    }
    frontmatter {
      date(formatString: "MMM D, YYYY")
      title
      description
      tags
      image
      author
      postType
      artistId
      articleTag
    }
  }

  recentPosts: allMarkdownRemark( 
    sort: { order: DESC, fields: [frontmatter___date] }
    limit: 8
    ){
    edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            templateKey
            image
            date(formatString: "MMM D, YYYY")
            tags
            postType
            author
            articleTag
          }
        }
      }
  }
}
`

